import React, { PureComponent } from 'react'
import { Snackbar } from '@material-ui/core'
import { isEmpty } from 'lodash'
import classNames from 'classnames'
import FlashMessageManager from './FlashMessageManager'
import 'assets/scss/commons/flash-message.scss'

export function showMessage(args) {
  const ref = FlashMessageManager.getDefault()
  if (ref) {
    ref.showMessage(args)
  }
}

export default class FlashMessage extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      messageData: {}
    }
  }

  componentDidMount () {
    FlashMessageManager.register(this)
  }

  componentWillUnmount() {
    FlashMessageManager.unregister(this)
  }

  showMessage(message) {
    clearTimeout(this.delayHideMessage)
    if (!isEmpty(message) && typeof message === 'object') {
      this.setState({ messageData: message }, () => {
        this.delayHideMessage = setTimeout(() => this.setState({ messageData: {} }), message.duration)
      })
      return
    }
    this.setState({ messageData: {} })
  }

  errorIcon = () => (
    <div className='flash-message__circle flash-message__circle__error'>
      <i className='icon icon-deny flash-message__icon' />
    </div>
  )

  successIcon = () => (
    <div className='flash-message__circle flash-message__circle__success'>
      <i className='icon icon-accept flash-message__icon' />
    </div>
  )

  getIcon = (type) => {
    switch (type) {
      case 'success':
        return this.successIcon()
      default:
        return this.errorIcon()
    }
  }

  render () {
    const { messageData } = this.state
    const { duration, type } = messageData
    return (
        <Snackbar
          open={!isEmpty(messageData)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          autoHideDuration={duration}
        >
          <div className={classNames({ 'flash-message': true, [`flash-message__${type}`]: true })}>
            {this.getIcon(type)}
            <span className='flash-message__text'>{messageData?.message}</span>
          </div>
        </Snackbar>
    )
  }
}